import { SelectionModel } from '@angular/cdk/collections';
import { CdkDropListGroup } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import {
    OportunidadesClienteDialogComponent,
    OportunidadesClienteDialogData,
} from '@shared/components/oportunidades-cliente-dialog/oportunidades-cliente-dialog.component';
import {
    VincularOportunidadeDialogComponent,
    VincularOportunidadeDialogData,
    VincularOportunidadeDialogResult,
} from '@shared/components/vincular-oportunidade-dialog/vincular-oportunidade-dialog.component';
import {
    DesvincularOportunidadeDialogComponent,
    DesvincularOportunidadeDialogData,
} from '@shared/components/desvincular-oportunidade-dialog/desvincular-oportunidade-dialog.component';
import {
    CriarOportunidadeDocumentoDialogComponent,
    CriarOportunidadeDocumentoDialogData,
    CriarOportunidadeDocumentoDialogResult,
} from '@shared/components/criar-oportunidade-documento-dialog/criar-oportunidade-documento-dialog.component';
import { Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, debounceTime, distinctUntilChanged, forkJoin, takeUntil } from 'rxjs';

import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import {
    ExtracaoDadosData,
    ExtracaoDadosModalComponent,
    FiltroExtracao,
} from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import { AcaoAutomacaoVendaEnum } from '@shared/enums/vendas/acao-automacao-venda.enum';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { OrigemVendaEnum } from '../../../shared/enums/vendas/origem-venda.enum';
import { ChaveEtapaKanbanEnum } from '../../../shared/enums/vendas/chave-etapa-kanban.enum';
import { MoverVendaEtapaErrorCodeEnum } from '@shared/enums/vendas/mover-venda-etapa-error-code.enum';
import { VendaTipoDocumentoEnum } from '../../../shared/enums/vendas/venda-tipo-documento.enum';
import { TipoProcessoKanbanEnum } from '../../../shared/enums/vendas/tipo-processo-kanban.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MaskService } from '../../../shared/services/mask.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { ProcessoVendaService } from '../../../shared/services/apis/vendas/processo-venda.service';
import { TagVendaService } from '../../../shared/services/apis/vendas/tag-venda.service';
import { MotivoTransicao } from '../../../shared/services/models/vendas/motivo-transicao.model';
import { TagVenda } from '../../../shared/services/models/vendas/tag-venda.model';
import { CriarModeloVendaRequest } from '../../../shared/services/requests/vendas/criar-modelo-venda.request';
import { ExcluirVendaRequest } from '../../../shared/services/requests/vendas/excluir-venda.request';
import { VendaExclusaoResultadoStruct } from '../../../shared/services/structs/vendas/venda-exclusao-resultado.struct';
import { MoverVendaEtapaRequest } from '../../../shared/services/requests/vendas/mover-venda-etapa.request';
import { VendaFiltroRequest } from '../../../shared/services/requests/vendas/venda-filtro.request';
import { GetVendaKanbanResponse } from '../../../shared/services/responses/vendas/get-venda-kanban.response';
import { VendaDocumentoStruct } from '../../../shared/services/structs/vendas/venda-documento.struct';
import { VendaEscopoStruct } from '../../../shared/services/structs/vendas/venda-escopo.struct';
import { LookupItemStruct } from '../../../shared/services/structs/vendas/lookup-item.struct';
import { ThemeService } from '../../../shared/services/utils/theme.service';
import { LimitDateValidator } from '../../../shared/validators/limit-date.validator';
import {
    PvConfirmarMovimentoDialogComponent,
    PvConfirmarMovimentoDialogData,
    PvConfirmarMovimentoDialogResult,
    cabecalhoDoMovimento,
} from './dialogs/pv-confirmar-movimento-dialog/pv-confirmar-movimento-dialog.component';
import {
    PvMotivoDialogComponent,
    PvMotivoDialogData,
    PvMotivoDialogResult,
} from './dialogs/pv-motivo-dialog/pv-motivo-dialog.component';
import {
    PvHistoricoDialogComponent,
    PvHistoricoDialogData,
} from './dialogs/pv-historico-dialog/pv-historico-dialog.component';
import {
    PvLancarFinanceiroDialogComponent,
    PvLancarFinanceiroDialogData,
} from './dialogs/pv-lancar-financeiro-dialog/pv-lancar-financeiro-dialog.component';
import {
    PvExcluirFinanceiroDialogComponent,
    PvExcluirFinanceiroDialogData,
} from './dialogs/pv-excluir-financeiro-dialog/pv-excluir-financeiro-dialog.component';
import { PvFinanceiroDialogComponent, PvFinanceiroDialogData } from './dialogs/pv-financeiro-dialog/pv-financeiro-dialog.component';
import {
    PvLancarEstoqueDialogComponent,
    PvLancarEstoqueDialogData,
} from './dialogs/pv-lancar-estoque-dialog/pv-lancar-estoque-dialog.component';
import {
    PvExcluirEstoqueDialogComponent,
    PvExcluirEstoqueDialogData,
} from './dialogs/pv-excluir-estoque-dialog/pv-excluir-estoque-dialog.component';
import { PvAlterarTagsDialogComponent, PvAlterarTagsDialogData } from './dialogs/pv-alterar-tags-dialog/pv-alterar-tags-dialog.component';
import { VdLiberacaoDialogComponent, VdLiberacaoDialogData, VdLiberacaoDialogResult } from '../venda-documento/components/vd-liberacao-dialog/vd-liberacao-dialog.component';
import { bloqueioDeOrcamentoVencido, motivosDaLiberacao } from '../venda-documento/components/vd-liberacao-dialog/venda-liberacao.regras';
import { LiberacaoPresencialStruct } from '../../../shared/services/structs/vendas/liberacao-presencial.struct';
import { MoverVendaEtapaIntegracaoStruct } from '@shared/services/structs/vendas/mover-venda-etapa-integracao.struct';
import {
    PvImpressaoListaDialogComponent,
    PvImpressaoListaDialogData,
} from './dialogs/pv-impressao-lista-dialog/pv-impressao-lista-dialog.component';
import { PvListaComponent } from './components/pv-lista/pv-lista.component';
import { PvRaiaComponent } from './components/pv-raia/pv-raia.component';
import {
    PV_CHAVE_FAIXA_ENVIO,
    PvColunaVm,
    PvMovimentoCard,
    PvLinhaListaVm,
    PvPeriodo,
    PvRecorteBoard,
    PvRaiaVm,
    PvVisao,
    PvDocumentoComOportunidade,
    PvPermissoesOportunidade,
    intervaloDoPeriodo,
    resolverPermissoesOportunidade,
    criarRaiasEsqueleto,
    formatarNumeroDocumento,
    montarLinhasLista,
    montarRaias,
    rotuloDocumento,
    PV_TEXTO_EXCLUSAO_COM_OPORTUNIDADE,
} from './processo-venda.models';
import { resolverCor } from '@shared/helpers/kanban-cor.helper';

/**
 * Processo de Venda — quadro operacional de orçamentos e pedidos.
 *
 * Esta é a ESTRUTURA BASE (task 147876): board, visão em lista, filtros e expandir/recolher.
 * Movimentação de card, criação de modelo, ocorrências e exclusão são da fase de mecânicas;
 * os botões correspondentes já existem, desabilitados, para a estrutura ficar correta.
 */
@Component({
    selector: 'app-processo-venda',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        MatTooltipModule,
        MatBadgeModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        CdkDropListGroup,
        CdkScrollable,
        HeaderComponent,
        EmptyListComponent,
        LoadingBoxDefaultListComponent,
        PvRaiaComponent,
        PvListaComponent,
    ],
    templateUrl: './processo-venda.component.html',
    styleUrls: ['./processo-venda.component.css'],
})
export class ProcessoVendaComponent implements OnInit, OnDestroy {
    public readonly moduloEnum = ModuloEnum.Vendas;
    public readonly funcionalidadeEnum = FuncionalidadeEnum.Vendas_ProcessoVenda;
    public readonly origemVendaEnum = OrigemVendaEnum;

    private readonly destroy$ = new Subject<void>();

    // ---------- permissões: sem bypass de master, como no resto do HUB ----------
    public readonly tipoDocumentoEnum = VendaTipoDocumentoEnum;

    public podeInserir = false;
    public podeAlterar = false;

    /** Por que "Alterar tags" está desabilitado (tooltip no wrapper: item desabilitado não dispara o próprio). */
    public get motivoAlterarTagsDesabilitado(): string {
        if (!this.podeAlterar) return 'Você não tem permissão para alterar documentos.';
        if (!this.listSelection.hasValue()) return 'Selecione ao menos um documento na lista.';
        return '';
    }
    public podeExcluir = false;
    /** Excluir financeiro do pedido (T08): Vendas_ProcessoVenda_ExcluirFinanceiro, sem bypass de master. */
    public podeExcluirFinanceiro = false;

    /** Excluir estoque do pedido (T11): Vendas_ProcessoVenda_ExcluirEstoque, sem bypass de master. */
    public podeExcluirEstoque = false;

    /**
     * Exportar tem permissão PRÓPRIA (200), como em toda tela do HUB que exporta — quem vê a
     * listagem não necessariamente pode levar a carteira inteira para uma planilha.
     */
    public podeExportar = false;

    /** Ações de oportunidade do card e da linha (RX-04, RX-05): resolvidas uma vez, no ngOnInit. */
    public permissoesOportunidade: PvPermissoesOportunidade = resolverPermissoesOportunidade([]);

    // ---------- estado da tela ----------
    public visao: PvVisao = 'kanban';
    public isCarregando = false;
    public isCabecalhoRecolhido = false;

    public raias: PvRaiaVm[] = [];

    /** Forma fantasma do board enquanto a primeira carga nao chega. */
    public readonly raiasEsqueleto: PvRaiaVm[] = criarRaiasEsqueleto();
    public linhasLista: PvLinhaListaVm[] = [];

    /** Paginação da lista, no padrão "Ver Mais" das demais listagens do HUB. */
    public paginaLista = 0;
    public isUltimaPaginaLista = false;
    public isCarregandoMaisLista = false;
    public escopo: VendaEscopoStruct | null = null;
    /** Total da LISTA, como o servidor filtrou (processo, período, modelos). O board conta pelas raias. */
    public totalRegistrosLista = 0;
    public isMostrarSomaColuna = true;

    public vendedoresDisponiveis: LookupItemStruct[] = [];
    public tagsDisponiveis: TagVenda[] = [];

    /**
     * Card sendo arrastado neste instante. Existe para as colunas se pintarem como destino
     * válido ou bloqueado DURANTE o arraste: sem isso a recusa só aparecia ao soltar, e em
     * silêncio — o card voltava e nada explicava o porquê.
     */
    public cardEmArraste: VendaDocumentoStruct | null = null;

    /** Coluna sob o cursor agora. Só tem significado durante o arraste. */
    private _colunaSobPonteiro: PvColunaVm | null = null;

    /**
     * Setter e não campo simples: mudar a coluna sob o ponteiro precisa refletir na classe do
     * body, e isso não é estado de template — o preview do arraste é criado pelo CDK fora deste
     * componente, então a única forma de alcançá-lo é por uma classe global.
     * Mesmo recurso que o alert-banner usa nesta base.
     */
    public set colunaSobPonteiro(coluna: PvColunaVm | null) {
        this._colunaSobPonteiro = coluna;
        this.sincronizarClasseDeArraste();
    }

    public get colunaSobPonteiro(): PvColunaVm | null {
        return this._colunaSobPonteiro;
    }

    /** Motivos ativos, vindos no board — o endpoint próprio deles exige permissão de Configurações. */
    public motivosDisponiveis: MotivoTransicao[] = [];


    public readonly listSelection = new SelectionModel<PvLinhaListaVm>(true, []);

    /** Recolhimento é estado de tela, não do servidor: sobrevive ao recarregar os dados. */
    private readonly raiasRecolhidas = new Set<string>();
    private readonly colunasRecolhidas = new Set<number>();

    private ultimaResposta: GetVendaKanbanResponse | null = null;

    /**
     * Itens crus da Lista, como vieram da API.
     *
     * PvLinhaListaVm já traz nome, ícone e COR da etapa resolvidos — e cor depende do tema. Sem
     * guardar o cru, trocar de tema com a Lista aberta deixaria os chips com a paleta anterior,
     * porque as linhas montadas não sabem se refazer. É o mesmo papel que ultimaResposta cumpre
     * para o board.
     */
    private itensLista: VendaDocumentoStruct[] = [];

    /**
     * Uma visão "desatualizada" precisa ir ao servidor na próxima vez que for exibida; uma
     * limpa é redesenhada do que já está em memória, sem rede.
     *
     * Isto existe porque, para o usuário, alternar Kanban/Lista é reorganizar a mesma tela — e
     * ele não pode sentir uma ida ao servidor nisso. As duas visões NÃO são derivavéis uma da
     * outra (o board traz 10 cards por coluna e os totais/config; a lista traz os 20 mais
     * recentes no geral), então a primeira exibição de cada uma busca. Da segunda em diante,
     * enquanto nenhum filtro mudar, alternar custa zero requisição.
     *
     * Nascem sujas: nada foi carregado ainda.
     */
    private isKanbanDesatualizado = true;
    private isListaDesatualizada = true;

    // ---------- filtros ----------
    public filterModel: FormGroup;
    public periodo: PvPeriodo = 'mes';

    /**
     * Teto do intervalo personalizado. Espelha VendaController.MesesMaximosDoPeriodo: o
     * servidor recusa mais que isso, e barrar no cliente evita a ida inútil.
     */
    public readonly limiteMeses = 3;

    @ViewChild('periodoMenuTrigger') private periodoMenuTrigger?: MatMenuTrigger;
    @ViewChild('filtrosMenuTrigger') private filtrosMenuTrigger?: MatMenuTrigger;

    /**
     * O menu de período é um rascunho, igual ao painel "Filtrar": fechar sem Aplicar tem que
     * devolver o que estava valendo. Estes três guardam o último estado aplicado.
     */
    private periodoAplicado: PvPeriodo = 'mes';
    private dataDeAplicada: Date | null = null;
    private dataAteAplicada: Date | null = null;
    private isPeriodoAplicadoNoMenu = false;
    public recorte: PvRecorteBoard = 'todos';

    /** Rascunho do painel "Filtrar": nada é aplicado até o Aplicar. */
    public rascunhoIdsVendedor: number[] = [];
    public rascunhoIdOrigem: number = OrigemVendaEnum.Todos;
    public rascunhoIdsTag: number[] = [];

    private idsVendedorAplicado: number[] = [];
    private idOrigemAplicado: number = OrigemVendaEnum.Todos;
    private idsTagAplicado: number[] = [];

    /**
     * Filtro da LISTA apenas. No board os modelos vêm sempre: a coluna Modelo existe no quadro,
     * e deixá-la vazia até alguém ligar um filtro faria parecer que os modelos sumiram. Na Lista
     * é o contrário — modelo ali é ruído no meio das negociações em andamento —, então lá o
     * interruptor continua fazendo sentido, no painel "Filtrar" e contando no badge.
     *
     * Quem garante isso é o servidor, que ignora este campo nos dois endpoints do board.
     */
    public isMostrarModelos = false;
    public rascunhoIsMostrarModelos = false;

    /**
     * Tamanho de página do board. Quem define é o backend (VendaController), que devolve o valor
     * usado na própria resposta — aqui ele serve só para calcular qual é a próxima página no
     * "Ver mais". Não existe cópia do número: se o servidor mudar, isto acompanha.
     */
    private get tamanhoPaginaKanban(): number {
        return this.ultimaResposta?.tamanhoPagina ?? 10;
    }

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly processoVendaService: ProcessoVendaService,
        private readonly tagVendaService: TagVendaService,
        private readonly authService: AuthService,
        private readonly themeService: ThemeService,
        private readonly alertService: AlertService,
        private readonly dialog: MatDialog,
        private readonly router: Router,
    ) {
        // Os controls PRECISAM se chamar dataDe/dataAte: o LimitDateValidator procura por
        // esses nomes no grupo e devolve os erros dataInvalida/intervaloExcedido no dataAte.
        this.filterModel = this.formBuilder.group(
            {
                searchText: [''],
                dataDe: [null as Date | null],
                dataAte: [null as Date | null],
            },
            { validators: LimitDateValidator.rangeLimit(this.limiteMeses) },
        );
    }

    public ngOnInit(): void {
        const usuario = this.authService.getUserInfos();
        this.podeInserir = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_Inserir) ?? false;
        this.podeAlterar = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_Alterar) ?? false;
        this.podeExcluir = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_Excluir) ?? false;
        this.podeExcluirFinanceiro = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_ExcluirFinanceiro) ?? false;
        this.podeExcluirEstoque = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_ExcluirEstoque) ?? false;
        this.podeExportar = usuario?.listaPermissoes?.includes(PermissaoEnum.Vendas_ProcessoVenda_Exportar) ?? false;
        this.permissoesOportunidade = resolverPermissoesOportunidade(usuario?.listaPermissoes);

        this.filterModel
            .get('searchText')
            ?.valueChanges.pipe(debounceTime(350), distinctUntilChanged(), takeUntil(this.destroy$))
            .subscribe(() => this.recarregar());

        // Trocar de tema é APRESENTAÇÃO: reaplica a cor sobre a VM que está na tela. Remontar
        // aqui — o que se fazia antes — descartava tudo que só existe em memória: o card
        // arrastado, o modelo recém-criado e as páginas de "Ver mais".
        this.themeService.themeChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => this.reaplicarCores());

        this.carregarTags();
        this.recarregar();
    }

    // ============================ carga ============================

    private montarFiltro(): VendaFiltroRequest {
        const intervalo =
            this.periodo === 'personalizado'
                ? {
                      inicio: this.filterModel.get('dataDe')?.value as Date | null,
                      fim: this.filterModel.get('dataAte')?.value as Date | null,
                  }
                : intervaloDoPeriodo(this.periodo);

        const paraIso = (data: Date | null): string | null =>
            data ? new Date(data.getTime() - data.getTimezoneOffset() * 60000).toISOString().slice(0, 10) : null;

        return {
            pesquisa: (this.filterModel.get('searchText')?.value as string) || null,
            // No Kanban a pilula so recolhe raias, entao nada de processo vai para a API —
            // filtrar no servidor faria os cards e totais das outras raias desaparecerem.
            // Na Lista ela filtra por processo de verdade.
            idTipoProcessoKanban: this.visao === 'lista' ? this.processoDoRecorte : null,
            idsVendedor: this.idsVendedorAplicado.length > 0 ? this.idsVendedorAplicado : null,
            idOrigem: this.idOrigemAplicado !== OrigemVendaEnum.Todos ? this.idOrigemAplicado : null,
            idsTagVenda: this.idsTagAplicado.length > 0 ? this.idsTagAplicado : null,
            dataInicial: paraIso(intervalo.inicio),
            dataFinal: paraIso(intervalo.fim),
            isMostrarModelos: this.isMostrarModelos,
        };
    }

    /**
     * Algum filtro mudou: as DUAS visões passam a estar desatualizadas, mas só a que está na
     * tela vai ao servidor agora. A outra busca quando (e se) o usuário for até ela — trocar de
     * aba sem nunca olhar a lista não deve custar uma requisição de lista.
     */
    public recarregar(): void {
        this.isKanbanDesatualizado = true;
        this.isListaDesatualizada = true;

        // Aplicar filtros limpa a seleção: os itens marcados podem nem estar mais na coleção.
        this.listSelection.clear();
        this.paginaLista = 0;
        this.isUltimaPaginaLista = false;

        this.exibirVisaoAtual();
    }

    /** Busca a visão da vez apenas se ela estiver suja; caso contrário não faz nada. */
    private exibirVisaoAtual(): void {
        if (this.visao === 'kanban') {
            if (this.isKanbanDesatualizado) this.carregarKanban();
            return;
        }

        if (this.isListaDesatualizada) this.carregarLista();
    }

    private carregarKanban(): void {
        this.isCarregando = true;

        this.processoVendaService
            .getKanban(this.montarFiltro())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    this.isCarregando = false;

                    if (resposta.isError) {
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    this.ultimaResposta = resposta;
                    this.escopo = resposta.escopo;
                    this.isMostrarSomaColuna = resposta.isMostrarSomaColuna;
                    this.vendedoresDisponiveis = resposta.vendedoresDisponiveis ?? [];
                    this.motivosDisponiveis = resposta.motivos ?? [];
                    this.remontarDoCache();

                    // Só aqui, no sucesso: se a chamada falhar a visão continua suja e tenta de
                    // novo na próxima exibição, em vez de ficar limpa exibindo dado velho.
                    this.isKanbanDesatualizado = false;
                },
                error: () => {
                    this.isCarregando = false;
                    this.alertService.show('Erro', 'Não foi possível carregar o quadro.', AlertType.error);
                },
            });
    }

    private carregarLista(): void {
        this.isCarregando = true;

        // A lista precisa dos rótulos de etapa e processo, que vêm com a configuração do board.
        // Sem o quadro carregado antes, as linhas ficariam sem etapa.
        //
        // Com o tamanho de página fixado no servidor, esta chamada devolve o board COMPLETO — não
        // mais uma amostra de 1 card por coluna. Então ela também deixa o Kanban carregado, e o
        // isKanbanDesatualizado pode ser limpo: ir para o quadro depois disso sai de graça.
        if (!this.ultimaResposta) {
            this.processoVendaService
                .getKanban(this.montarFiltro())
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: resposta => {
                        if (!resposta.isError) {
                            this.ultimaResposta = resposta;
                            this.escopo = resposta.escopo;
                            this.isMostrarSomaColuna = resposta.isMostrarSomaColuna;
                            this.vendedoresDisponiveis = resposta.vendedoresDisponiveis ?? [];
                            this.motivosDisponiveis = resposta.motivos ?? [];
                            this.remontarDoCache();
                            this.isKanbanDesatualizado = false;
                        }
                        this.buscarLista();
                    },
                    error: () => this.buscarLista(),
                });

            return;
        }

        this.buscarLista();
    }

    private buscarLista(pagina = 0): void {
        const ehPrimeiraPagina = pagina === 0;

        if (ehPrimeiraPagina) {
            // A lista recarrega a coleção inteira, então volta ao esqueleto em vez de esmaecer:
            // manter linhas velhas na tela enquanto o filtro mudou seria mostrar dado errado.
            this.linhasLista = [];
            this.itensLista = [];
            this.isCarregando = true;
            // Funil único de "a coleção foi substituída": zera paginação e seleção aqui, e não
            // em cada chamador, senão o caminho do recorte esqueceria de fazê-lo.
            this.isUltimaPaginaLista = false;
            this.listSelection.clear();
        } else {
            this.isCarregandoMaisLista = true;
        }

        this.processoVendaService
            .getLista(this.montarFiltro(), pagina)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    this.isCarregando = false;
                    this.isCarregandoMaisLista = false;

                    if (resposta.isError) {
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    const itens = resposta.itens ?? [];

                    this.escopo = resposta.escopo ?? this.escopo;
                    this.totalRegistrosLista = resposta.totalRegistros;
                    this.paginaLista = pagina;
                    this.itensLista = ehPrimeiraPagina ? itens : [...this.itensLista, ...itens];
                    this.remontarLinhasLista();
                    this.isUltimaPaginaLista = this.linhasLista.length >= resposta.totalRegistros || itens.length === 0;
                    this.isListaDesatualizada = false;
                },
                error: () => {
                    this.isCarregando = false;
                    this.isCarregandoMaisLista = false;
                    this.alertService.show('Erro', 'Não foi possível carregar a lista.', AlertType.error);
                },
            });
    }

    /** "Ver Mais" da lista — concatena a próxima página, sem refazer a coleção. */
    public proximaPaginaLista(): void {
        if (this.isCarregandoMaisLista || this.isUltimaPaginaLista) return;

        this.buscarLista(this.paginaLista + 1);
    }

    /**
     * Remonta as linhas da Lista a partir dos itens crus. Precisa das raias prontas: é delas que
     * saem o nome, o ícone e a cor da etapa de cada linha.
     */
    private remontarLinhasLista(): void {
        this.linhasLista = montarLinhasLista(this.itensLista, this.raias);
    }

    /**
     * Reconstrói as raias a partir da última resposta do servidor.
     *
     * Chamar SOMENTE depois de uma resposta nova. Tudo que vive apenas em memória — card
     * arrastado, modelo recém-criado, páginas de "Ver mais" — está fora do `ultimaResposta` e é
     * descartado aqui. Recolhimento e tema NÃO passam por este método: eles mutam a VM.
     */
    private remontarDoCache(): void {
        if (!this.ultimaResposta) return;

        this.raias = montarRaias(
            this.ultimaResposta,
            this.themeService.isDarkMode,
            this.raiasRecolhidas,
            this.colunasRecolhidas,
        );

        // O recolhimento por recorte depende das raias já existirem, então vem depois da
        // montagem. Uma passada basta: ele agora aplica o estado NA raia, e antes só preenchia o
        // Set — que obrigava a montar o board duas vezes para o recolhimento aparecer.
        if (this.recorte !== 'todos') this.aplicarRecolhimentoDoRecorte();

        // As raias são novas, e é delas que as linhas da Lista tiram cor e rótulo da etapa.
        if (this.itensLista.length > 0) this.remontarLinhasLista();
    }

    private carregarTags(): void {
        this.tagVendaService
            .getAll('', 0, 200)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    if (!resposta.isError) this.tagsDisponiveis = resposta.listaTags ?? [];
                },
            });
    }


    // ============================ movimentação de card ============================

    /**
     * Passado ao CDK como predicado de entrada de cada coluna: enquanto o card paira, a coluna
     * de destino pergunta se aceita. Recusar aqui é melhor do que aceitar e reverter — a coluna
     * não abre espaço e o usuário vê que o destino é inválido antes de soltar.
     *
     * Propriedade de seta porque o CDK chama sem contexto.
     */
    public iniciarArraste(card: VendaDocumentoStruct): void {
        this.cardEmArraste = card;
        this.colunaSobPonteiro = null;
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        // Classe global tem que sair com a tela: sair do board no meio de um arraste deixaria
        // ela grudada no body e afetaria o arraste de qualquer outra tela.
        document.body.classList.remove('pv-arraste-sem-destino');
    }

    /**
     * Fim do arraste. Vem do cdkDragEnded, que dispara DEPOIS da animação de retorno do CDK — e
     * é justamente por isso que a limpeza mora aqui e em nenhum lugar antes.
     *
     * Cheguei a limpar também no cdkDragReleased (que dispara ao soltar, antes da animação),
     * achando inofensivo. Não era: zerar a coluna sob o ponteiro remove a classe do body, a
     * transição do preview volta, e a animação enganosa reaparece. Este comentário existe para
     * a próxima pessoa não repetir.
     */
    public encerrarArraste(): void {
        this.cardEmArraste = null;
        this.colunaSobPonteiro = null;
    }

    /** Publica no body se o cursor está sobre um destino que recusa o card em voo. */
    private sincronizarClasseDeArraste(): void {
        document.body.classList.toggle('pv-arraste-sem-destino', this.isPonteiroSobDestinoInvalido);
    }

    /**
     * O cursor está sobre uma coluna que recusa este card.
     *
     * Quando isso acontece, o CDK não move o fantasma (a coluna nega a entrada) e ele fica
     * parado na última coluna que aceitou — o cursor aponta para um lugar e o fantasma para
     * outro. A tela usa isto para esconder o fantasma enquanto durar a contradição.
     */
    public get isPonteiroSobDestinoInvalido(): boolean {
        if (!this.cardEmArraste || !this.colunaSobPonteiro) return false;
        if (this.colunaSobPonteiro.idEtapaKanban === this.cardEmArraste.idEtapaKanban) return false;

        return !this.aceitaCard(this.cardEmArraste, this.colunaSobPonteiro);
    }

    public readonly aceitaCard = (card: VendaDocumentoStruct, destino: PvColunaVm): boolean => {
        if (!this.podeAlterar) return false;

        const origem = this.colunaDaEtapa(card.idEtapaKanban);

        // A regra é do servidor: ele já mandou, por coluna, para onde este usuário pode mover.
        // Aqui é só pertencimento — nenhuma condição de negócio é reavaliada.
        return origem?.idsEtapaDestinoPermitida.includes(destino.idEtapaKanban) ?? false;
    };

    /**
     * Card solto numa coluna válida.
     *
     * O movimento acontece na tela primeiro e é desfeito se o servidor recusar. O contrário —
     * esperar a resposta para mover — deixaria o card "grudado" no lugar antigo por um instante
     * depois de solto, que é exatamente a sensação de travamento que um quadro não pode ter.
     */
    public moverCard(evento: PvMovimentoCard): void {
        const origem = this.colunaDaEtapa(evento.card.idEtapaKanban);
        if (!origem) return;

        // Sem revalidar: o predicado do CDK já usou a lista do servidor para deixar o card entrar
        // aqui, e se algo tiver escapado é o POST que recusa — com a mensagem dele, não com uma
        // segunda redação da mesma regra.
        if (evento.destino.isMotivoObrigatorio) {
            this.pedirMotivo(evento.destino, (idMotivoTransicao, justificativa) =>
                this.pedirLiberacaoSeVencido(evento.card, origem, evento.destino, (liberacao) =>
                    this.aplicarMovimento(evento.card, origem, evento.destino, idMotivoTransicao, justificativa, liberacao)),
            );
            return;
        }

        this.pedirLiberacaoSeVencido(evento.card, origem, evento.destino, (liberacao) =>
            this.aplicarMovimento(evento.card, origem, evento.destino, null, null, liberacao));
    }

    /**
     * §12.7: orçamento vencido só converte em pedido com liberação de um supervisor — o mesmo diálogo do salvar, aberto
     * depois do motivo. Conversão é o movimento que atravessa processos (a regra do servidor); "vencido" é o selo do card.
     * Quem tem alçada (master) não pede liberação a si mesmo, como no salvar; o servidor aplica a mesma isenção.
     */
    private pedirLiberacaoSeVencido(
        card: VendaDocumentoStruct,
        origem: PvColunaVm,
        destino: PvColunaVm,
        aoSeguir: (liberacao: LiberacaoPresencialStruct | null) => void,
    ): void {
        const ehConversao = card.idVendaTipoDocumento === VendaTipoDocumentoEnum.Orcamento
            && destino.idConfigKanbanProcesso !== origem.idConfigKanbanProcesso;

        if (!ehConversao || !card.isVencido || !card.dataValidade || this.authService.getUserInfos()?.master) {
            aoSeguir(null);
            return;
        }

        const bloqueios = [bloqueioDeOrcamentoVencido(card.dataValidade)];

        this.dialog
            .open<VdLiberacaoDialogComponent, VdLiberacaoDialogData, VdLiberacaoDialogResult>(VdLiberacaoDialogComponent, {
                data: { bloqueios },
                width: '640px',
                maxWidth: '96vw',
                autoFocus: false,
                disableClose: true,
            })
            .afterClosed()
            .subscribe(credencial => {
                if (!credencial) {
                    this.alertService.show('Documento não movido', 'A liberação foi cancelada e o orçamento continua onde estava.', AlertType.warning);
                    return;
                }

                aoSeguir({
                    email: credencial.email,
                    senha: credencial.senha,
                    observacao: credencial.observacao,
                    motivos: motivosDaLiberacao(bloqueios),
                });
            });
    }

    /** Abre o painel de motivo; só chama de volta se o usuário confirmar. */
    private pedirMotivo(destino: PvColunaVm, aoConfirmar: (idMotivoTransicao: number, justificativa: string | null) => void): void {
        this.dialog
            .open(PvMotivoDialogComponent, {
                data: {
                    nomeDestino: destino.nome,
                    // Lista vinculada vazia = qualquer motivo ativo serve. Mesma convenção do servidor.
                    motivos: destino.idsMotivoTransicao.length > 0
                        ? this.motivosDisponiveis.filter(m => destino.idsMotivoTransicao.includes(m.idMotivoTransicao))
                        : this.motivosDisponiveis,
                } as PvMotivoDialogData,
            })
            .afterClosed()
            .subscribe((resultado: PvMotivoDialogResult | undefined) => {
                if (!resultado) return;

                aoConfirmar(resultado.idMotivoTransicao, resultado.justificativa);
            });
    }

    /**
     * `confirmacao` é o segundo passo do voltar etapa ou cancelar com integrações (T17): o usuário viu o alerta e disse o
     * que desfazer; o mesmo movimento é reaplicado com a flag e a escolha.
     */
    private aplicarMovimento(
        card: VendaDocumentoStruct,
        origem: PvColunaVm,
        destino: PvColunaVm,
        idMotivoTransicao: number | null,
        justificativa: string | null,
        liberacaoPresencial: LiberacaoPresencialStruct | null = null,
        confirmacao: PvConfirmarMovimentoDialogResult | null = null,
    ): void {
        this.transferirCardNaTela(card, origem, destino);

        const request = new MoverVendaEtapaRequest();
        request.idVenda = card.idVenda;
        request.idEtapaKanbanDestino = destino.idEtapaKanban;
        request.idMotivoTransicao = idMotivoTransicao;
        request.justificativa = justificativa;
        // A senha vive só neste request: o orquestrador confere no /Auth e zera o campo.
        request.liberacaoPresencial = liberacaoPresencial;
        request.isMovimentoConfirmado = confirmacao != null;
        request.idsVendaTipoIntegracaoDesfazer = confirmacao?.idsVendaTipoIntegracaoDesfazer ?? [];

        this.processoVendaService
            .moverEtapa(request)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    // T17: pedido com lançamentos voltando de etapa ou indo para Cancelado. Nada foi gravado: o card volta,
                    // o alerta pergunta o que desfazer e, confirmando, o movimento é reaplicado com a escolha.
                    if (resposta.isError && resposta.errorCode === MoverVendaEtapaErrorCodeEnum.ConfirmarIntegracoes) {
                        this.transferirCardNaTela(card, destino, origem);
                        this.pedirConfirmacaoDoMovimento(card, destino, resposta.integracoes, (escolha) =>
                            this.aplicarMovimento(card, origem, destino, idMotivoTransicao, justificativa, liberacaoPresencial, escolha));
                        return;
                    }

                    if (resposta.isError) {
                        this.transferirCardNaTela(card, destino, origem);
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    // O destino decide se o card ainda lança estoque e financeiro (etapa final ou especial), sem recarregar.
                    card.isEtapaFinalizada = resposta.isEtapaFinalizada;

                    // Conversão muda o DOCUMENTO, não só a coluna: tipo e marcador de origem
                    // vêm na resposta e são aplicados no card em memória. Sem isso o card
                    // continuaria se desenhando como orçamento (rodapé e chip) até o próximo
                    // carregamento do board.
                    if (resposta.isConversao) {
                        card.idVendaTipoDocumento = resposta.idVendaTipoDocumento;
                        card.isOrigemOrcamento = resposta.isOrigemOrcamento;

                        // Aviso explícito porque aqui não foi só uma troca de coluna: o
                        // documento mudou de natureza.
                        this.alertService.show(
                            'Sucesso',
                            `Orçamento nº ${card.numero} convertido em pedido de venda com sucesso.`,
                            AlertType.success,
                        );
                    }

                    // A automação da transição que não pôde rodar (reserva de estoque) vira aviso; o card moveu.
                    for (const aviso of resposta.avisosAutomacao ?? []) this.alertService.show('Aviso', aviso, AlertType.warning);

                    // A saída de estoque pela automação muda o card (selo E e menu de estoque): o board recarrega. O
                    // mesmo quando o movimento desfez financeiro ou estoque (T17): os selos F e E saem do card.
                    if (resposta.automacoes?.some((a) => a.acaoAutomacaoVenda === AcaoAutomacaoVendaEnum.SaidaEstoque)
                        || (confirmacao?.idsVendaTipoIntegracaoDesfazer.length ?? 0) > 0) this.recarregar();

                    // A Lista passa a estar desatualizada: o documento mudou de etapa, e ela
                    // exibe a etapa em coluna própria.
                    this.isListaDesatualizada = true;
                },
                error: () => {
                    this.transferirCardNaTela(card, destino, origem);
                    // Falha de REDE/HTTP (404, 500, timeout). Regra recusada não cai aqui: volta
                    // em isError com a mensagem do servidor. Textos diferentes para o toast
                    // identificar a camada sozinho.
                    this.alertService.show('Erro', 'Não foi possível falar com o servidor.', AlertType.error);
                },
            });
    }

    /** Abre o alerta de voltar etapa ou cancelar com integrações (T17); só chama de volta se o usuário confirmar. */
    private pedirConfirmacaoDoMovimento(
        card: VendaDocumentoStruct,
        destino: PvColunaVm,
        integracoes: MoverVendaEtapaIntegracaoStruct[],
        aoConfirmar: (escolha: PvConfirmarMovimentoDialogResult) => void,
    ): void {
        this.dialog
            .open<PvConfirmarMovimentoDialogComponent, PvConfirmarMovimentoDialogData, PvConfirmarMovimentoDialogResult>(
                PvConfirmarMovimentoDialogComponent,
                {
                    data: {
                        ...cabecalhoDoMovimento(destino.chave, destino.nome),
                        rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                        integracoes,
                    },
                    autoFocus: false,
                },
            )
            .afterClosed()
            .subscribe((escolha) => {
                if (!escolha) {
                    this.alertService.show('Documento não movido', 'O pedido continua onde estava.', AlertType.warning);
                    return;
                }
                aoConfirmar(escolha);
            });
    }

    /**
     * Move o card entre as duas colunas em memória, ajustando contador e soma das duas.
     *
     * Recalcular os totais localmente evita recarregar o quadro a cada arraste. O preço é que
     * eles ficam com o número da PÁGINA carregada até a próxima busca — aceitável, porque a
     * alternativa é o board inteiro piscar a cada movimento.
     */
    private transferirCardNaTela(card: VendaDocumentoStruct, de: PvColunaVm, para: PvColunaVm): void {
        const indice = de.cards.findIndex(c => c.idVenda === card.idVenda);
        if (indice >= 0) de.cards.splice(indice, 1);

        card.idEtapaKanban = para.idEtapaKanban;
        para.cards = [card, ...para.cards];

        de.totalRegistros = Math.max(0, de.totalRegistros - 1);
        para.totalRegistros += 1;

        de.somaValorTotal = Math.max(0, de.somaValorTotal - (card.valorTotal ?? 0));
        para.somaValorTotal += card.valorTotal ?? 0;
    }

    /**
     * "Criar modelo" do menu do card.
     *
     * Ao contrário do arraste, aqui NADA acontece na tela antes da resposta: o modelo não existe
     * até o servidor criá-lo, e ele é quem define o número (`M-02`) e o id. Desenhar um card
     * antes seria inventar um documento.
     */
    public criarModelo(card: VendaDocumentoStruct): void {
        const origem = this.colunaDaEtapa(card.idEtapaKanban);
        if (!origem) return;

        const request = new CriarModeloVendaRequest();
        request.idVenda = card.idVenda;

        this.processoVendaService
            .criarModelo(request)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    if (resposta.isError) {
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    this.inserirModeloNaTela(resposta.modelo, origem);

                    const numero = formatarNumeroDocumento(
                        resposta.modelo.numero,
                        resposta.modelo.idVendaTipoDocumento,
                    );

                    this.alertService.show(
                        'Sucesso',
                        `Modelo nº ${numero} criado a partir do orçamento nº ${card.numero}.`,
                        AlertType.success,
                    );

                    this.inserirModeloNaLista(resposta.modelo);
                },
                error: () => {
                    this.alertService.show('Erro', 'Não foi possível falar com o servidor.', AlertType.error);
                },
            });
    }

    /**
     * Coloca o modelo recém-criado na coluna Modelo do MESMO processo do orçamento de origem —
     * cada processo tem a sua, e procurar só pela chave acertaria a coluna errada.
     *
     * Vale para as duas visões: criado pela Lista, o board em memória já fica certo, e voltar
     * para o quadro não precisa de recarga.
     */
    private inserirModeloNaTela(modelo: VendaDocumentoStruct, origem: PvColunaVm): void {
        for (const raia of this.raias) {
            const colunaModelo = raia.colunas.find(
                c =>
                    c.chave === ChaveEtapaKanbanEnum.Modelo &&
                    c.idConfigKanbanProcesso === origem.idConfigKanbanProcesso,
            );

            if (!colunaModelo) continue;

            colunaModelo.cards = [modelo, ...colunaModelo.cards];
            colunaModelo.totalRegistros += 1;
            colunaModelo.somaValorTotal += modelo.valorTotal ?? 0;

            // O cabeçalho da raia de Orçamento não conta modelos (o servidor também os deixa fora do
            // total e da soma): só a coluna Modelo contabiliza o que acabou de nascer.

            return;
        }
    }

    // ============================ impressão ============================

    /**
     * Impressão da listagem.
     *
     * Respeita os FILTROS, não a seleção: o usuário imprime o recorte que está vendo, e limitar à
     * seleção obrigaria a marcar dezenas de linhas para tirar um relatório do mês.
     *
     * As raias vão junto porque é delas que saem nome e cor da etapa de cada linha — a mesma
     * tradução que a Lista faz na tela.
     */
    public imprimirListagem(): void {
        this.dialog.open(PvImpressaoListaDialogComponent, {
            // A largura vai AQUI, e não no :host do dialog: o Material aplica width/maxWidth
            // inline no painel, e o default dele (560px) vencia qualquer min-width do conteúdo —
            // o resultado era a tabela transbordando e o cabeçalho saindo da vista.
            width: '1060px',
            maxWidth: '95vw',
            data: {
                filtro: this.montarFiltro(),
                raias: this.raias,
                rotuloPeriodo: this.rotuloPeriodo,
            } as PvImpressaoListaDialogData,
        });
    }

    /**
     * Exportação da listagem em CSV.
     *
     * Caminho padrão do HUB: o modal compartilhado cria o pedido na fila de extrações e acompanha
     * o processamento. O arquivo é montado depois pelo ATS.Hub.Worker.Vendas e chega por
     * notificação e e-mail.
     *
     * Os filtros saem do MESMO `montarFiltro()` que alimenta a tela — é o que garante que o
     * arquivo traga o recorte que o usuário está vendo, e não uma segunda montagem que amanhã
     * diverge da primeira.
     *
     * NÃO vão daqui o escopo de vendedor nem as etapas visíveis ao perfil: isso é ACESSO, e o
     * worker resolve sozinho a partir do usuário do pedido, lendo os bancos direto. Mandar daqui
     * seria o mesmo que não ter regra.
     */
    public exportarListagem(): void {
        const filtro = this.montarFiltro();

        // O modal confirma o que vai ser extraído, então cada linha mostra a DATA, não o
        // rótulo do atalho: "Do mês" repetido nos dois campos não diz qual recorte saiu.
        const exibirData = (iso: string | null | undefined): string => (iso ? iso.split('-').reverse().join('/') : '—');

        // O array é o que o modal exibe E o que ele serializa como json_filtros: o
        // formControlName vira o nome da propriedade lida pelo worker.
        const filtros: FiltroExtracao[] = [
            {
                label: 'Período',
                formControlName: 'dataInicial',
                valor: filtro.dataInicial,
                valorExibicao: exibirData(filtro.dataInicial),
            },
            {
                label: 'Período (fim)',
                formControlName: 'dataFinal',
                valor: filtro.dataFinal,
                valorExibicao: exibirData(filtro.dataFinal),
            },
        ];

        if (filtro.pesquisa) {
            filtros.push({ label: 'Pesquisa', formControlName: 'pesquisa', valor: filtro.pesquisa });
        }

        if (filtro.idTipoProcessoKanban != null) {
            filtros.push({
                label: 'Processo',
                formControlName: 'idTipoProcessoKanban',
                valor: filtro.idTipoProcessoKanban,
                valorExibicao: this.rotuloRecorte,
            });
        }

        if (filtro.idsVendedor?.length) {
            filtros.push({
                label: 'Vendedor',
                formControlName: 'idsVendedor',
                valor: filtro.idsVendedor,
                valorExibicao: this.vendedoresDisponiveis
                    .filter(v => filtro.idsVendedor!.includes(v.id))
                    .map(v => v.descricao)
                    .join(', '),
            });
        }

        if (filtro.idOrigem != null) {
            filtros.push({
                label: 'Origem',
                formControlName: 'idOrigem',
                valor: filtro.idOrigem,
                valorExibicao:
                    filtro.idOrigem === OrigemVendaEnum.OriginadoDeOrcamento
                        ? 'Convertidos de orçamento'
                        : 'Criados diretamente',
            });
        }

        if (filtro.idsTagVenda?.length) {
            filtros.push({
                label: 'Tags',
                formControlName: 'idsTagVenda',
                valor: filtro.idsTagVenda,
                valorExibicao: this.tagsDisponiveis
                    .filter(t => filtro.idsTagVenda!.includes(t.idTagVenda))
                    .map(t => t.descricao)
                    .join(', '),
            });
        }

        if (filtro.isMostrarModelos) {
            filtros.push({
                label: 'Modelos',
                formControlName: 'isMostrarModelos',
                valor: true,
                valorExibicao: 'Incluídos',
            });
        }

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: {
                titulo: 'Exportar Processo de Venda',
                tipoExtracao: TipoExtracaoEnum.VendasCSV,
                origemPedidoExportacao: OrigemPedidoExportacaoEnum.VendasProcessoVenda,
                filtros,
                possuiAutomacao: false,
            } as ExtracaoDadosData,
            panelClass: 'extracao-dados-panel',
            disableClose: true,
        });
    }

    // ============================ exclusão ============================

    /** Exclusão a partir do menu do card ou da linha: um documento só. */
    public excluirDocumento(documento: VendaDocumentoStruct): void {
        const rotulo = rotuloDocumento(documento.numero, documento.idVendaTipoDocumento);

        this.confirmarExclusao(
            'Excluir documento',
            `<p>Tem certeza que deseja excluir o <strong>${rotulo}</strong>?</p>` +
                '<p>Ele sai do quadro e da listagem. O histórico é preservado.</p>' +
                // RN-15: excluir o documento vinculado também o tira da oportunidade.
                (documento.idOportunidade != null ? `<p>${PV_TEXTO_EXCLUSAO_COM_OPORTUNIDADE}</p>` : ''),
            [documento.idVenda],
        );
    }

    /**
     * "Alterar tags" do "Ações (n)" da Lista (T15, §10.3). Depois de gravar, as duas visões em memória estão
     * velhas (o card e a linha mostram as tags), então recarrega a visão atual e marca a outra.
     */
    public alterarTagsSelecionados(): void {
        const idsVenda = this.listSelection.selected.map(linha => linha.documento.idVenda);

        if (idsVenda.length === 0) return;

        const data: PvAlterarTagsDialogData = { idsVenda, tags: this.tagsDisponiveis };

        this.dialog
            .open(PvAlterarTagsDialogComponent, { width: '520px', data })
            .afterClosed()
            .subscribe(resultado => {
                if (!resultado?.success) return;

                this.recarregar();
            });
    }

    /** Exclusão a partir do "Ações (n)" da Lista. */
    public excluirSelecionados(): void {
        const ids = this.listSelection.selected.map(linha => linha.documento.idVenda);

        if (ids.length === 0) return;

        const temVinculado = this.listSelection.selected.some(linha => linha.documento.idOportunidade != null);

        this.confirmarExclusao(
            'Excluir documentos',
            `<p>Tem certeza que deseja excluir <strong>${ids.length}</strong> documento(s)?</p>` +
                '<p>Documentos que já geraram nota ou lançamento não são excluídos, e a tela dirá quais.</p>' +
                (temVinculado ? `<p>${PV_TEXTO_EXCLUSAO_COM_OPORTUNIDADE}</p>` : ''),
            ids,
        );
    }

    private confirmarExclusao(titulo: string, innerHtml: string, ids: number[]): void {
        this.dialog
            .open(ConfirmModalComponent, {
                width: '440px',
                data: { title: titulo, innerHtml, buttonConfirm: 'Excluir', buttonClose: 'Cancelar' },
            })
            .afterClosed()
            .subscribe(resultado => {
                if (!resultado?.confirm) return;

                this.enviarExclusao(ids);
            });
    }

    private enviarExclusao(ids: number[]): void {
        const request = new ExcluirVendaRequest();
        request.idsVenda = ids;

        this.processoVendaService
            .excluir(request)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    // isError é falha da OPERAÇÃO. Documento recusado por regra vem em resultados.
                    if (resposta.isError) {
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    const resultados = resposta.resultados ?? [];
                    const excluidos = resultados.filter(r => r.isExcluido);
                    const recusados = resultados.filter(r => !r.isExcluido);

                    for (const resultado of excluidos) this.removerDocumentoDaTela(resultado.idVenda);

                    this.relatarExclusao(excluidos, recusados);
                    if (resposta.avisoDescricao) this.alertService.show('Aviso', resposta.avisoDescricao, AlertType.warning);
                },
                error: () => {
                    this.alertService.show('Erro', 'Não foi possível falar com o servidor.', AlertType.error);
                },
            });
    }

    /**
     * Tira o documento das duas visões em memória, sem recarregar.
     *
     * As duas, e não só a que está aberta: a outra continua carregada e mostraria um documento que
     * não existe mais assim que o usuário trocasse de aba.
     */
    private removerDocumentoDaTela(idVenda: number): void {
        for (const raia of this.raias) {
            for (const coluna of raia.colunas) {
                const indice = coluna.cards.findIndex(c => c.idVenda === idVenda);
                if (indice < 0) continue;

                const [card] = coluna.cards.splice(indice, 1);
                coluna.cards = [...coluna.cards];

                coluna.totalRegistros = Math.max(0, coluna.totalRegistros - 1);
                coluna.somaValorTotal = Math.max(0, coluna.somaValorTotal - (card.valorTotal ?? 0));

                // Modelo não conta no cabeçalho da raia (é molde, não negociação); a coluna conta os dela.
                if (coluna.chave === ChaveEtapaKanbanEnum.Modelo) continue;

                if (raia.totalCards != null) raia.totalCards = Math.max(0, raia.totalCards - 1);
                if (raia.somaValorTotal != null) {
                    raia.somaValorTotal = Math.max(0, raia.somaValorTotal - (card.valorTotal ?? 0));
                }
            }
        }

        const naLista = this.itensLista.findIndex(d => d.idVenda === idVenda);

        if (naLista >= 0) {
            this.itensLista.splice(naLista, 1);
            this.totalRegistrosLista = Math.max(0, this.totalRegistrosLista - 1);
            this.remontarLinhasLista();
        }

        // A seleção guarda a LINHA, que o remontarLinhasLista acabou de recriar.
        const selecionada = this.listSelection.selected.find(l => l.documento.idVenda === idVenda);
        if (selecionada) this.listSelection.deselect(selecionada);
    }

    /**
     * Conta o que aconteceu.
     *
     * Um lote parcial não cabe num toast: havendo recusa, abre o resumo listando documento e
     * motivo — dizer "alguns não foram excluídos" deixaria o usuário sem saber quais nem por quê.
     */
    private relatarExclusao(
        excluidos: VendaExclusaoResultadoStruct[],
        recusados: VendaExclusaoResultadoStruct[],
    ): void {
        if (recusados.length === 0) {
            const texto =
                excluidos.length === 1
                    ? `${rotuloDocumento(excluidos[0].numero, excluidos[0].idVendaTipoDocumento)} excluído com sucesso.`
                    : `${excluidos.length} documentos excluídos com sucesso.`;

            this.alertService.show('Sucesso', texto, AlertType.success);
            return;
        }

        // Recusa de um documento só: o motivo cabe no toast e é mais leve que abrir um modal.
        if (excluidos.length === 0 && recusados.length === 1) {
            this.alertService.show('Atenção', recusados[0].motivo ?? 'Documento não excluído.', AlertType.warning);
            return;
        }

        const linhas = recusados
            .map(r => `<li><strong>${rotuloDocumento(r.numero, r.idVendaTipoDocumento)}</strong> — ${r.motivo}</li>`)
            .join('');

        const resumo =
            excluidos.length > 0
                ? `<p>${excluidos.length} documento(s) excluído(s). Os abaixo não puderam ser excluídos:</p>`
                : '<p>Nenhum documento foi excluído:</p>';

        this.dialog.open(ConfirmModalComponent, {
            width: '520px',
            data: {
                title: 'Resultado da exclusão',
                innerHtml: `${resumo}<ul>${linhas}</ul>`,
                buttonClose: 'Fechar',
            },
        });
    }

    /**
     * "Lançar financeiro" (T05): o diálogo busca o documento e as configurações, mostra o que cada
     * recebimento vai virar no Finanças e lança. Lançou → o card passa a "em leitura": recarrega.
     */
    public lancarFinanceiro(card: VendaDocumentoStruct): void {
        this.dialog
            .open(PvLancarFinanceiroDialogComponent, {
                data: {
                    idVenda: card.idVenda,
                    rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                } as PvLancarFinanceiroDialogData,
                width: '680px',
                maxWidth: '96vw',
                autoFocus: false,
            })
            .afterClosed()
            .subscribe((lancou: boolean | undefined) => {
                if (lancou) this.recarregar();
            });
    }

    /** "Excluir financeiro" (T08): tudo ou nada, com o resumo e os bloqueios vindos do Finanças. */
    public excluirFinanceiro(card: VendaDocumentoStruct): void {
        this.dialog
            .open(PvExcluirFinanceiroDialogComponent, {
                data: {
                    idVenda: card.idVenda,
                    rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                } as PvExcluirFinanceiroDialogData,
                width: '680px',
                maxWidth: '96vw',
                autoFocus: false,
            })
            .afterClosed()
            .subscribe((excluiu: boolean | undefined) => {
                if (excluiu) this.recarregar();
            });
    }

    /**
     * "Lançar estoque" (T10): o diálogo mostra o que sai de cada local e as pendências por item, e lança. Lançou → o
     * card passa a "em leitura" e ganha o indicador E: recarrega.
     */
    public lancarEstoque(card: VendaDocumentoStruct): void {
        this.dialog
            .open(PvLancarEstoqueDialogComponent, {
                data: {
                    idVenda: card.idVenda,
                    rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                } as PvLancarEstoqueDialogData,
                width: '680px',
                maxWidth: '96vw',
                autoFocus: false,
            })
            .afterClosed()
            .subscribe((lancou: boolean | undefined) => {
                if (lancou) this.recarregar();
            });
    }

    /** "Excluir estoque" (T11): tudo ou nada, com o resumo das movimentações do Produto. */
    public excluirEstoque(card: VendaDocumentoStruct): void {
        this.dialog
            .open(PvExcluirEstoqueDialogComponent, {
                data: {
                    idVenda: card.idVenda,
                    rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                } as PvExcluirEstoqueDialogData,
                width: '680px',
                maxWidth: '96vw',
                autoFocus: false,
            })
            .afterClosed()
            .subscribe((excluiu: boolean | undefined) => {
                if (excluiu) this.recarregar();
            });
    }

    /** Indicador F: os lançamentos do financeiro do pedido, só para consultar (com link para o Finanças). */
    public verFinanceiro(card: VendaDocumentoStruct): void {
        this.dialog.open(PvFinanceiroDialogComponent, {
            data: {
                idVenda: card.idVenda,
                rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
            } as PvFinanceiroDialogData,
            width: '680px',
            maxWidth: '96vw',
            autoFocus: false,
        });
    }

    /**
     * "Ver histórico" — o histórico do documento.
     *
     * O modal busca sozinho: o histórico é grande demais para vir junto de todo card do board,
     * e é lido de vez em quando, não a cada carga da tela.
     */
    public verHistorico(card: VendaDocumentoStruct): void {
        this.dialog.open(PvHistoricoDialogComponent, {
            data: {
                idVenda: card.idVenda,
                rotuloDocumento: rotuloDocumento(card.numero, card.idVendaTipoDocumento),
                // Anotar no histórico é mexer num documento que já existe: Alterar, não Inserir.
                podeAlterar: this.podeAlterar,
                // O board não carrega a configuração do Pedido de Venda (o GET dela exige permissão de
                // Configurações): a exclusão da anotação fica liberada aqui e a API confere
                // `isBloquearExclusaoOcorrencia` no DELETE; a recusa volta em isError e vira toast.
                bloquearExclusaoOcorrencia: false,
            } as PvHistoricoDialogData,
        });
    }

    /** "Ver oportunidades do cliente" — o dialog trata permissão e navegação sozinho. */
    public verOportunidadesCliente(card: VendaDocumentoStruct): void {
        if (!card.idPessoaCliente) return;

        this.dialog.open(OportunidadesClienteDialogComponent, {
            width: '1040px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            autoFocus: false,
            data: {
                idPessoaCliente: card.idPessoaCliente,
                nomeCliente: card.nomePessoaCliente ?? '',
                titulo: 'Oportunidades do cliente',
                origem: 'processo-venda',
            } as OportunidadesClienteDialogData,
        });
    }

    // ============================ oportunidade do documento (D3) ============================

    /** "Ver oportunidade #N" e a marca do card: a ficha no CRM. Fora do escopo, só avisa (RX-06). */
    public verOportunidade(card: VendaDocumentoStruct): void {
        if (card.idOportunidade == null) return;

        if (card.isOportunidadeForaDoEscopo) {
            this.alertService.show('Aviso', 'Esta oportunidade é de outro vendedor e está fora do seu escopo.', AlertType.warning);
            return;
        }

        this.router.navigate(['/vendas/crm'], { queryParams: { idOportunidade: card.idOportunidade } });
    }

    /**
     * "Criar oportunidade" (RX-01). O "Vincular a ela" do aviso de oportunidade em andamento fecha este
     * dialog e abre o de vincular, já com ela marcada.
     */
    public criarOportunidade(card: VendaDocumentoStruct): void {
        if (!card.idPessoaCliente) return;

        this.dialog
            .open(CriarOportunidadeDocumentoDialogComponent, {
                width: '700px',
                maxWidth: '95vw',
                autoFocus: false,
                data: {
                    idVenda: card.idVenda,
                    idVendaTipoDocumento: card.idVendaTipoDocumento,
                    numero: card.numero,
                    idPessoaCliente: card.idPessoaCliente,
                    nomeCliente: card.nomePessoaCliente ?? '',
                    idVendedor: card.idVendedor || null,
                    podeVincular: !this.permissoesOportunidade.motivoBloqueioVinculo,
                } as CriarOportunidadeDocumentoDialogData,
            })
            .afterClosed()
            .subscribe((resultado: CriarOportunidadeDocumentoDialogResult | undefined) => {
                if (resultado?.idOportunidadeParaVincular != null) {
                    this.vincularOportunidade(card, resultado.idOportunidadeParaVincular);
                    return;
                }

                if (!resultado?.criada) return;

                // A etapa não volta na criação: a marca fica sem ela até a próxima carga.
                this.atualizarOportunidadeNaTela(card.idVenda, {
                    idOportunidade: resultado.criada.idOportunidade,
                    codigoOportunidade: resultado.criada.codigo,
                    tituloOportunidade: resultado.criada.titulo,
                    nomeEtapaOportunidade: null,
                    isOportunidadeForaDoEscopo: false,
                });
            });
    }

    /** "Vincular a oportunidade" (RX-02): as abertas do mesmo cliente, dentro do escopo. */
    public vincularOportunidade(card: VendaDocumentoStruct, idOportunidadeSugerida: number | null = null): void {
        if (!card.idPessoaCliente) return;

        this.dialog
            .open(VincularOportunidadeDialogComponent, {
                width: '700px',
                maxWidth: '95vw',
                autoFocus: false,
                data: {
                    idVenda: card.idVenda,
                    idVendaTipoDocumento: card.idVendaTipoDocumento,
                    numero: card.numero,
                    idPessoaCliente: card.idPessoaCliente,
                    nomeCliente: card.nomePessoaCliente ?? '',
                    idOportunidadeSugerida,
                } as VincularOportunidadeDialogData,
            })
            .afterClosed()
            .subscribe((resultado: VincularOportunidadeDialogResult | undefined) => {
                if (!resultado) return;

                this.atualizarOportunidadeNaTela(card.idVenda, {
                    idOportunidade: resultado.oportunidade.idOportunidade,
                    codigoOportunidade: resultado.oportunidade.codigo,
                    tituloOportunidade: resultado.oportunidade.titulo,
                    nomeEtapaOportunidade: resultado.oportunidade.nomeEtapa,
                    isOportunidadeForaDoEscopo: false,
                });
            });
    }

    /** "Desvincular da oportunidade" (RX-03): confirma no dialog; documento e oportunidade continuam. */
    public desvincularOportunidade(card: VendaDocumentoStruct): void {
        if (card.idOportunidade == null) return;

        this.dialog
            .open(DesvincularOportunidadeDialogComponent, {
                width: '480px',
                maxWidth: '95vw',
                autoFocus: false,
                data: {
                    idVenda: card.idVenda,
                    idVendaTipoDocumento: card.idVendaTipoDocumento,
                    numero: card.numero,
                    codigoOportunidade: card.codigoOportunidade ?? '',
                } as DesvincularOportunidadeDialogData,
            })
            .afterClosed()
            .subscribe((desvinculou: boolean | undefined) => {
                if (!desvinculou) return;

                this.atualizarOportunidadeNaTela(card.idVenda, {
                    idOportunidade: null,
                    codigoOportunidade: null,
                    tituloOportunidade: null,
                    nomeEtapaOportunidade: null,
                    isOportunidadeForaDoEscopo: null,
                });
            });
    }

    /**
     * Aplica o vínculo novo ao documento nas duas visões em memória, sem recarregar — como a exclusão faz.
     * As duas, porque a outra continua carregada e mostraria o estado antigo ao trocar de aba.
     */
    private atualizarOportunidadeNaTela(idVenda: number, oportunidade: PvDocumentoComOportunidade): void {
        const documentos = [
            ...this.raias.flatMap(raia => raia.colunas.flatMap(coluna => coluna.cards)),
            ...this.itensLista,
        ].filter(documento => documento.idVenda === idVenda);

        for (const documento of documentos) {
            documento.idOportunidade = oportunidade.idOportunidade ?? null;
            documento.codigoOportunidade = oportunidade.codigoOportunidade ?? null;
            documento.tituloOportunidade = oportunidade.tituloOportunidade ?? null;
            documento.nomeEtapaOportunidade = oportunidade.nomeEtapaOportunidade ?? null;
            documento.isOportunidadeForaDoEscopo = oportunidade.isOportunidadeForaDoEscopo ?? null;
        }
    }

    /**
     * O modelo na visão em Lista.
     *
     * Só entra em tela quando a Lista está aberta E "Mostrar modelos" ligado — o filtro é dela,
     * e com ele desligado o registro existe mas não é da coleção que o usuário pediu. Fora
     * disso basta marcá-la para recarregar: ou ela não está carregada, ou vai buscar de novo
     * antes de aparecer.
     */
    private inserirModeloNaLista(modelo: VendaDocumentoStruct): void {
        if (this.visao !== 'lista' || !this.isMostrarModelos) {
            this.isListaDesatualizada = true;
            return;
        }

        // No topo: a Lista vem ordenada por data, e o modelo acabou de nascer.
        this.itensLista = [modelo, ...this.itensLista];
        this.totalRegistrosLista += 1;
        this.remontarLinhasLista();
    }

    /** Localiza a coluna que hoje contém determinada etapa, em qualquer raia. */
    private colunaDaEtapa(idEtapaKanban: number): PvColunaVm | null {
        for (const raia of this.raias) {
            const coluna = raia.colunas.find(c => c.idEtapaKanban === idEtapaKanban);
            if (coluna) return coluna;
        }

        return null;
    }

    // ============================ interações ============================

    /**
     * Contador do cabeçalho. No board é a soma das raias de PROCESSO que estão no recorte da pílula
     * (as faixas não têm total próprio: o total do processo já inclui os documentos delas), e no
     * recorte "Envio e retirada" são os cards da própria faixa. Na Lista é o total filtrado pelo
     * servidor, que já respeita o processo e "Mostrar modelos".
     */
    public get totalRegistrosExibido(): number {
        if (this.visao !== 'kanban') return this.totalRegistrosLista;

        if (this.recorte === 'envioRetirada') {
            return this.raias
                .filter(raia => raia.chave === PV_CHAVE_FAIXA_ENVIO)
                .reduce((soma, raia) => soma + raia.colunas.reduce((s, coluna) => s + coluna.totalRegistros, 0), 0);
        }

        return this.raias
            .filter(raia => raia.totalCards != null && this.raiaEstaNoRecorte(raia))
            .reduce((soma, raia) => soma + (raia.totalCards ?? 0), 0);
    }

    public trocarVisao(visao: PvVisao): void {
        if (this.visao === visao) return;

        // Alternar de visão preserva os filtros aplicados — é o que a story pede.
        this.visao = visao;

        // "Envio e retirada" não é oferecida na Lista: mantê-la selecionada deixaria a pílula
        // exibindo um recorte que a listagem não sabe aplicar. Trocar o recorte muda o filtro
        // de processo que a lista usa, então ela precisa ser buscada de novo.
        if (visao === 'lista' && this.recorte === 'envioRetirada') {
            this.recorte = 'todos';
            this.isListaDesatualizada = true;
        }

        // Nada de recarregar(): alternar de visão não invalida coisa alguma. Se a visão de
        // destino já está carregada e nenhum filtro mudou, a troca é instantânea e a seleção e
        // as páginas de "Ver mais" que o usuário já tinha continuam onde estavam.
        this.exibirVisaoAtual();
    }

    public alternarCabecalho(): void {
        this.isCabecalhoRecolhido = !this.isCabecalhoRecolhido;
    }

    /**
     * Recolher/expandir é estado de TELA: muda a raia que já está montada.
     *
     * O Set continua sendo atualizado, mas com outro papel — ele é a memória do recolhimento para
     * a PRÓXIMA montagem, quando chegar resposta nova do servidor.
     */
    public alternarRaia(raia: PvRaiaVm): void {
        raia.isRecolhida = !raia.isRecolhida;

        if (raia.isRecolhida) this.raiasRecolhidas.add(raia.chave);
        else this.raiasRecolhidas.delete(raia.chave);
    }

    /** Mesma razão do alternarRaia: estado de tela, sem remontagem. */
    public alternarColuna(coluna: PvColunaVm): void {
        coluna.isRecolhida = !coluna.isRecolhida;

        if (coluna.isRecolhida) this.colunasRecolhidas.add(coluna.idEtapaKanban);
        else this.colunasRecolhidas.delete(coluna.idEtapaKanban);
    }

    /** "Ver mais" de uma coluna: busca a próxima página e concatena, sem refazer o quadro. */
    public verMais(coluna: PvColunaVm): void {
        if (coluna.isCarregandoMais) return;

        coluna.isCarregandoMais = true;
        const proximaPagina = Math.floor(coluna.cards.length / this.tamanhoPaginaKanban);

        this.processoVendaService
            .getKanbanEtapa(coluna.idEtapaKanban, this.montarFiltro(), proximaPagina)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: resposta => {
                    coluna.isCarregandoMais = false;

                    if (resposta.isError) {
                        this.alertService.show('Atenção', resposta.errorDescription, AlertType.warning);
                        return;
                    }

                    coluna.cards = [...coluna.cards, ...(resposta.coluna?.cards ?? [])];
                    coluna.temMais = resposta.coluna?.temMais ?? false;
                    coluna.totalRegistros = resposta.coluna?.totalRegistros ?? coluna.totalRegistros;
                },
                error: () => {
                    coluna.isCarregandoMais = false;
                    this.alertService.show('Erro', 'Não foi possível carregar mais cards.', AlertType.error);
                },
            });
    }

    /**
     * Abre a tela do Documento Comercial em branco.
     *
     * O TIPO vai na rota, e nao em estado compartilhado, porque e ele que decide a tela inteira:
     * quais secoes existem, quais campos cada uma mostra e em que processo o documento nasce.
     * Na rota, o link e colavel e o F5 nao perde o contexto.
     */
    public novoDocumento(idVendaTipoDocumento: VendaTipoDocumentoEnum): void {
        this.router.navigate(['/vendas/processo-venda/documento'], { queryParams: { tipo: idVendaTipoDocumento } });
    }

    // ============================ novo a partir do modelo ============================

    /** Modelos oferecidos no "+ Novo orçamento" (protótipo: "a partir do modelo"). */
    public modelosParaNovo: VendaDocumentoStruct[] = [];
    public isCarregandoModelos = false;

    /**
     * Busca os modelos a cada abertura do menu, pela coluna Modelo SEM os filtros do board: a
     * lista de modelos não depende da pesquisa, do período nem do vendedor filtrado na tela (o
     * escopo do usuário continua valendo — é o servidor quem o aplica).
     */
    public carregarModelosParaNovo(): void {
        const colunasModelo = this.raias
            .flatMap(raia => raia.colunas)
            .filter(coluna => coluna.chave === ChaveEtapaKanbanEnum.Modelo);

        if (!colunasModelo.length) {
            this.modelosParaNovo = [];
            return;
        }

        this.isCarregandoModelos = true;

        forkJoin(colunasModelo.map(coluna => this.processoVendaService.getKanbanEtapa(coluna.idEtapaKanban, {}, 0)))
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: respostas => {
                    this.isCarregandoModelos = false;
                    this.modelosParaNovo = respostas
                        .filter(resposta => !resposta.isError)
                        .flatMap(resposta => resposta.coluna?.cards ?? []);
                },
                error: () => {
                    this.isCarregandoModelos = false;
                    this.modelosParaNovo = [];
                },
            });
    }

    /** O modelo não tem nome próprio: o número dele e o cliente de onde o molde saiu. */
    public rotuloModelo(modelo: VendaDocumentoStruct): string {
        const numero = formatarNumeroDocumento(modelo.numero, modelo.idVendaTipoDocumento);

        return modelo.nomePessoaCliente ? `${numero} — ${modelo.nomePessoaCliente}` : numero;
    }

    public tooltipModelo(modelo: VendaDocumentoStruct): string {
        const numero = formatarNumeroDocumento(modelo.numero, modelo.idVendaTipoDocumento);

        return `Criar orçamento a partir do modelo ${numero} — ${modelo.qtdItens} ${modelo.qtdItens === 1 ? 'item' : 'itens'}`;
    }

    /** Usar um modelo é clonar o modelo: abre o orçamento novo com o conteúdo dele (task 148656). */
    public novoAPartirDoModelo(modelo: VendaDocumentoStruct): void {
        this.clonar(modelo);
    }

    /**
     * Clique no card (ou na linha da visao em lista) abre o documento — story 1.1.
     *
     * So o id vai na rota: o TIPO vem do proprio documento no GET, e nao do card, senao o board
     * viraria fonte de uma informacao que e do documento.
     */
    public abrirCard(card: VendaDocumentoStruct): void {
        this.router.navigate(['/vendas/processo-venda/documento', card.idVenda]);
    }

    /**
     * Clonar (task 148656): abre a tela do documento NOVO com o conteúdo do card — nada é gravado
     * aqui. O Modelo clonado vira orçamento (é o "usar este modelo").
     */
    public clonar(card: VendaDocumentoStruct): void {
        const tipoDestino = card.idVendaTipoDocumento === VendaTipoDocumentoEnum.Modelo
            ? VendaTipoDocumentoEnum.Orcamento
            : card.idVendaTipoDocumento;

        this.router.navigate(['/vendas/processo-venda/documento'], {
            queryParams: { tipo: tipoDestino, origem: card.idVenda },
        });
    }

    public alternarTodosDaLista(): void {
        if (this.listSelection.selected.length === this.linhasLista.length) this.listSelection.clear();
        else this.linhasLista.forEach(linha => this.listSelection.select(linha));
    }

    // ============================ filtros ============================

    public selecionarPeriodo(periodo: PvPeriodo): void {
        this.periodo = periodo;
    }

    /**
     * Um clique numa opção de período, vindo de qualquer um dos dois contêineres.
     *
     * Na pílula (desktop) o clique é a decisão: aplica e fecha o menu. Dentro do painel
     * "Filtrar" (mobile) ele só marca o rascunho — lá quem decide é o Aplicar do painel, junto
     * com Vendedor, Origem e Tags. "Do intervalo" nunca aplica no clique, nos dois casos: ele
     * apenas revela os campos de data.
     */
    public escolherPeriodo(periodo: PvPeriodo, aplicarAgora: boolean): void {
        this.selecionarPeriodo(periodo);

        if (aplicarAgora && periodo !== 'personalizado') this.aplicarPeriodo();
    }

    /** Máscara DD/MM/AAAA nos dois campos do intervalo, igual às listagens do HUB. */
    public onDateInput(evento: Event, control: 'dataDe' | 'dataAte'): void {
        MaskService.onDateInput(evento, this.filterModel.get(control));
    }

    /** Menu abriu: o que houver ali dentro ainda é rascunho até alguém clicar em Aplicar. */
    public prepararPeriodoIntervalo(): void {
        this.isPeriodoAplicadoNoMenu = false;
    }

    public cancelarPeriodoIntervalo(): void {
        this.restaurarPeriodoAplicado();
        this.isPeriodoAplicadoNoMenu = true;
        setTimeout(() => this.periodoMenuTrigger?.closeMenu());
    }

    /** Fechou clicando fora, sem Aplicar: descarta o rascunho. */
    public onPeriodoMenuClosed(): void {
        if (!this.isPeriodoAplicadoNoMenu) this.restaurarPeriodoAplicado();
    }

    /** Só há o que validar no intervalo personalizado; os períodos fixos são sempre válidos. */
    private periodoEscolhidoValido(): boolean {
        return this.periodo !== 'personalizado' || this.intervaloPersonalizadoValido();
    }

    public aplicarPeriodo(): void {
        if (!this.periodoEscolhidoValido()) return;

        this.isPeriodoAplicadoNoMenu = true;
        this.salvarPeriodoAplicado();
        this.recarregar();
        setTimeout(() => this.periodoMenuTrigger?.closeMenu());
    }

    /**
     * Os erros de intervalo vêm do LimitDateValidator, que os grava direto no control dataAte —
     * por isso eles são checados ANTES do required, senão o control já está inválido e a
     * mensagem genérica esconde a específica.
     */
    private intervaloPersonalizadoValido(): boolean {
        const dataDe = this.filterModel.get('dataDe');
        const dataAte = this.filterModel.get('dataAte');

        dataDe?.markAsTouched();
        dataAte?.markAsTouched();

        if (dataAte?.hasError('dataInvalida')) {
            this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
            return false;
        }

        if (dataAte?.hasError('intervaloExcedido')) {
            this.alertService.show(
                'Atenção',
                `O intervalo máximo permitido é de ${this.limiteMeses} meses.`,
                AlertType.warning,
            );
            return false;
        }

        if (!dataDe?.value || !dataAte?.value) {
            this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
            return false;
        }

        return true;
    }

    private salvarPeriodoAplicado(): void {
        this.periodoAplicado = this.periodo;
        this.dataDeAplicada = this.clonarData(this.filterModel.get('dataDe')?.value as Date | null);
        this.dataAteAplicada = this.clonarData(this.filterModel.get('dataAte')?.value as Date | null);
    }

    private restaurarPeriodoAplicado(): void {
        this.periodo = this.periodoAplicado;
        this.filterModel.patchValue(
            { dataDe: this.clonarData(this.dataDeAplicada), dataAte: this.clonarData(this.dataAteAplicada) },
            { emitEvent: false },
        );
    }

    /** Clona para o rascunho não escrever no estado aplicado por referência. */
    private clonarData(data: Date | null): Date | null {
        return data ? new Date(data.getTime()) : null;
    }

    /**
     * Pílula da toolbar.
     *
     * No Kanban isso é recolhimento, não filtro: as outras raias continuam ali, fechadas, e o
     * usuário não perde a noção do que existe fora do recorte escolhido. Como nada muda na
     * coleção, também não há ida ao servidor — a troca é instantânea.
     */
    public selecionarRecorte(recorte: PvRecorteBoard): void {
        this.recorte = recorte;

        if (this.visao === 'lista') {
            this.recarregar();
            return;
        }

        // No board o recorte só recolhe raias — nada de rede. Mas ele TAMBÉM é o filtro de
        // processo da Lista (processoDoRecorte), então a lista que estiver em memória deixou de
        // valer. Sem esta linha, ir para a Lista depois de trocar o processo mostraria o
        // recorte anterior.
        this.isListaDesatualizada = true;

        // Sem remontar: o aplicarRecolhimentoDoRecorte já mexeu nas raias que estão na tela.
        this.aplicarRecolhimentoDoRecorte();
    }

    /**
     * Traduz o recorte para o filtro que a Lista entende. Ela filtra por PROCESSO, então
     * "Envio e retirada" não existe lá: aqueles documentos são pedidos de venda como
     * quaisquer outros, e a distinção entre fluxo e faixa só faz sentido no board.
     */
    private get processoDoRecorte(): number | null {
        if (this.recorte === 'orcamento') return TipoProcessoKanbanEnum.Orcamento;
        if (this.recorte === 'pedido') return TipoProcessoKanbanEnum.PedidoDeVenda;
        return null;
    }

    /** Fecha toda raia fora do recorte; em "todos", abre tudo. */
    /**
     * A pílula de processo recolhe as raias que ficaram fora do recorte.
     *
     * Aplica o estado NA RAIA e no Set ao mesmo tempo: a raia é o que a tela lê agora, o Set é o
     * que sobrevive até a próxima montagem. Antes isto só preenchia o Set e o chamador remontava
     * o board — que era o terceiro caminho pelo qual o arraste do usuário era desfeito.
     */
    private aplicarRecolhimentoDoRecorte(): void {
        this.raiasRecolhidas.clear();

        for (const raia of this.raias) {
            const recolher = this.recorte !== 'todos' && !this.raiaEstaNoRecorte(raia);

            raia.isRecolhida = recolher;
            if (recolher) this.raiasRecolhidas.add(raia.chave);
        }
    }

    /**
     * Reaplica a cor de raias e colunas no tema atual, sem tocar em card nenhum.
     *
     * É por isto que a VM guarda o idKanbanCor ao lado da cor resolvida: dá para trocar de tema
     * mexendo só na cor, em vez de reconstruir o board a partir da resposta do servidor.
     */
    private reaplicarCores(): void {
        const cores = this.ultimaResposta?.cores ?? [];
        const isDarkMode = this.themeService.isDarkMode;

        for (const raia of this.raias) {
            raia.cor = resolverCor(raia.idKanbanCor, cores, isDarkMode);

            for (const coluna of raia.colunas) {
                coluna.cor = resolverCor(coluna.idKanbanCor, cores, isDarkMode);
            }
        }

        // A Lista tira cor e rótulo da etapa das raias; sem isto os chips ficam na paleta antiga.
        if (this.itensLista.length > 0) this.remontarLinhasLista();
    }

    private raiaEstaNoRecorte(raia: PvRaiaVm): boolean {
        const ehFaixaEnvio = raia.chave === PV_CHAVE_FAIXA_ENVIO;

        switch (this.recorte) {
            case 'orcamento':
                return raia.idTipoProcessoKanban === TipoProcessoKanbanEnum.Orcamento;

            // Os desfechos são etapas do próprio pedido, então entram junto. A faixa de
            // rotinas externas não: ela tem opção própria.
            case 'pedido':
                return raia.idTipoProcessoKanban === TipoProcessoKanbanEnum.PedidoDeVenda && !ehFaixaEnvio;

            case 'envioRetirada':
                return ehFaixaEnvio;

            default:
                return true;
        }
    }

    /** Abre o painel com o rascunho igual ao que está aplicado hoje. */
    public prepararRascunhoFiltros(): void {
        this.rascunhoIdsVendedor = [...this.idsVendedorAplicado];
        this.rascunhoIdOrigem = this.idOrigemAplicado;
        this.rascunhoIdsTag = [...this.idsTagAplicado];
        this.rascunhoIsMostrarModelos = this.isMostrarModelos;

        // No mobile o período é editado DENTRO deste painel, então o Cancelar dele também
        // precisa devolver o período ao que estava valendo. No desktop isto é inofensivo: o
        // período já está aplicado, e restaurar o aplicado sobre ele mesmo não muda nada.
        this.restaurarPeriodoAplicado();
    }

    public aplicarFiltros(): void {
        this.idsVendedorAplicado = [...this.rascunhoIdsVendedor];
        this.idOrigemAplicado = this.rascunhoIdOrigem;
        // O período pode ter sido escolhido aqui dentro (mobile), então ele é validado e
        // gravado junto. No desktop já veio aplicado pela pílula e isto é um no-op.
        if (!this.periodoEscolhidoValido()) return;

        this.idsTagAplicado = [...this.rascunhoIdsTag];
        this.isMostrarModelos = this.rascunhoIsMostrarModelos;
        this.salvarPeriodoAplicado();
        this.recarregar();
        this.fecharPainelFiltros();
    }

    /**
     * Fechar é responsabilidade nossa: o painel abre por cima do próprio botão que o abriu, então
     * sem uma saída explícita o usuário não tem onde clicar para sair dele.
     */
    public fecharPainelFiltros(): void {
        setTimeout(() => this.filtrosMenuTrigger?.closeMenu());
    }

    /** Cancelar descarta o rascunho E sai — restaurar sem fechar deixaria o painel aberto à toa. */
    public cancelarFiltros(): void {
        this.prepararRascunhoFiltros();
        this.fecharPainelFiltros();
    }

    public limparFiltros(): void {
        this.filterModel.reset({ searchText: '', dataDe: null, dataAte: null }, { emitEvent: false });
        this.periodo = 'mes';
        this.salvarPeriodoAplicado();
        this.recorte = 'todos';
        this.raiasRecolhidas.clear();
        this.idsVendedorAplicado = [];
        this.idOrigemAplicado = OrigemVendaEnum.Todos;
        this.idsTagAplicado = [];
        this.isMostrarModelos = false;
        this.rascunhoIsMostrarModelos = false;
        this.recarregar();
    }

    /**
     * Badge do botão Filtrar. Conta Vendedor, Origem, Tags e "Mostrar modelos" — tudo que está
     * dentro do painel e não tem indicação visual própria. Período e Processo ficam de fora:
     * cada um tem a sua pílula, que já mostra o estado no rótulo.
     */
    public get qtdFiltrosAvancados(): number {
        let qtd = 0;
        if (this.idsVendedorAplicado.length > 0) qtd++;
        if (this.idOrigemAplicado !== OrigemVendaEnum.Todos) qtd++;
        if (this.idsTagAplicado.length > 0) qtd++;
        // Só na Lista: no board o interruptor nem aparece, e contá-lo daria um badge que o
        // usuário não conseguiria explicar abrindo o painel.
        if (this.visao === 'lista' && this.isMostrarModelos) qtd++;
        return qtd;
    }

    public get rotuloPeriodo(): string {
        switch (this.periodo) {
            case 'hoje':
                return 'Hoje';
            case 'semana':
                return 'Da semana';
            case 'mes':
                return 'Do mês';
            case 'ultimos30':
                return 'Últimos 30 dias';
            default:
                return 'Do intervalo';
        }
    }

    public get rotuloRecorte(): string {
        switch (this.recorte) {
            case 'orcamento':
                return 'Orçamento';
            case 'pedido':
                return 'Pedido de venda';
            case 'envioRetirada':
                return 'Envio e retirada';
            default:
                return 'Todos os processos';
        }
    }

    /**
     * Faixa de escopo acima do board. Só aparece em escopo restritivo — quem vê tudo não
     * precisa ser lembrado disso a cada carga.
     */
    public get textoEscopo(): string | null {
        if (!this.escopo || this.escopo.isSemRestricao) return null;

        const nome = this.escopo.nomeVendedor ?? 'você';

        return this.escopo.qtdSubordinados > 0
            ? `Escopo de visualização: os registros de ${nome} e da sua equipe (${this.escopo.qtdSubordinados} vendedores).`
            : `Escopo de visualização: apenas os registros em que ${nome} é o vendedor responsável.`;
    }

    /** Só o filtro de vendedor faz sentido quando há mais de um responsável visível. */
    public get exibeFiltroVendedor(): boolean {
        return this.vendedoresDisponiveis.length > 1;
    }
}
